
let initialState = {
    'Anonymous':true,
    'Loaded':false,
    'Role':'Neznámý uživatel',
    'Username':'',
    'DisplayName':'',
    'FamilyName':''
  };
  
  export const userReducer = (state: any = initialState, action: any) => {
  
      switch (action.type) {
          case 'USER_LOGIN':
  
             var newState  = {...state};
  
             var payload = JSON.parse(action.payload);
             
             newState.Role = payload.role;
             newState.Anonymous = payload.anonymous;
             newState.Username = payload.username;
             newState.FamilyName = payload.familyName;
             newState.DisplayName = payload.displayName;
             newState.Loaded = true;
  
             return newState;
       
  
          case 'USER_LOGOUT':
              
              var newState  = {...state};
  
              var payload = JSON.parse(action.payload);
              
              newState.Role = payload.role;
              newState.Anonymous = payload.anonymous;
              newState.Username = payload.username;
              newState.FamilyName = '';
              newState.DisplayName = '';
              newState.Loaded = true;

              return newState;
  
      }
  
      return state;
  }